<template>
  <v-container fluid>
    <LoadingModal :is-loading="isUploading" v-if="isUploading"/>

    <v-form
        v-else
        id="speciesPhotoForm"
        class="fill-height"
        v-model="valid"
        lazy-validation
        ref="form"
    >
      <v-row>
        <div class="header">
          <h2>Добавление фото вида вида в природе</h2>
        </div>
        <div class="horizontal-rule"/>

        <v-container fluid>
          <v-row v-for="(item, index) in allForms" :class="index === 0 ? 'mt-0' : 'mt-6'" :key="index">
            <v-col class="pa-0" sm="6">
              <v-card tile class="pa-5" >
                <v-text-field
                    :readonly="index!==0"
                    :disabled="index!==0"
                    v-model="species"
                    autocomplete="off"
                    label="Название вида для которого добавляется фотография"
                    :rules="nameRules"
                />
                <v-text-field
                    v-model="item.description"
                    autocomplete="off"
                    label="Описание к фотографии"
                    :rules="nameRules"
                />
              </v-card>
            </v-col>

            <v-col class="pa-0" sm="6">
              <v-card height="100%" tile elevation="3" class="pa-5 d-flex align-center">
                <v-file-input
                    v-model="item.photo"
                    counter-string=""
                    :rules="fileRules"
                    accept="image/*"
                    name="scans"
                    color="blue darken-4"
                    counter
                    label="Прикрепите фото нажав сюда"
                    placeholder=""
                    prepend-icon="mdi-paperclip"
                    outlined
                    required
                    @change="logShit"
                >
                </v-file-input>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn @click="addNewForm" x-large icon v-on="on" color="primary">
              <v-icon x-large> mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Добавить ещё одну форму для фото</span>
        </v-tooltip>

        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn @click="() => {if (allForms.length > 1) allForms.pop()}" x-large icon v-on="on" color="error">
              <v-icon x-large> mdi-minus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Убрать последнюю форму</span>
        </v-tooltip>

      </v-row>


      <v-row class="mt-4">
        <v-spacer></v-spacer>
        <v-card tile class="mt-1 me-auto" >
          <v-btn text tile @click="sendPhoto">Сохранить</v-btn>
        </v-card>
        <v-card tile class="mt-1 me-auto" >
          <v-btn color="red" text tile @click="() => this.$refs.form.reset()">Очистить формы</v-btn>
        </v-card>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {createSpeciesPhoto, deleteSpeciesPhoto, fetchSpeciesPhoto} from "@/services/speciesAPI";
import LoadingModal from "@/components/UI/LoadingModal";
import ToastService from "@/services/toastService";

export default {
  name: "PhotoInNatureCreation",
  components: {LoadingModal},


  data () {
    return {
      isUploading: false,
      valid: true,
      species: '',
      allForms: [{
        description: '',
        photo: [],
      }],

      photosAmount: 1,

      succeededAmount: 0,

      overallAfterFail: 0,

      fileRules: [
        v => (!!v && v.size > 1) || 'Добавьте фото',
      ],
      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],
    }
  },

  methods: {
    logShit() {
      console.log(this);
    },

    addNewForm() {
      this.allForms.push({
        description: '',
        photo: []
      })
    },

    async sendPhoto() {
      if (this.$refs.form.validate()) {
        try {
          this.succeededAmount = 0
          this.isUploading = true
          for (const item of this.allForms) {
            await createSpeciesPhoto(item.photo, this.species, item.description)
            this.succeededAmount++
          }
          await this.$router.push('collections')
        } catch (e) {
          await fetchSpeciesPhoto(this.species).then((data) => {
            this.overallAfterFail = data.photos.length
          })
          for (let i = 0; i < this.succeededAmount; i++) {
            this.overallAfterFail--
            await deleteSpeciesPhoto(this.species, this.species, this.species, this.overallAfterFail)
          }
          try {
          if(e.response.status === 409) throw `Фотография номер ${this.succeededAmount + 1} не соответствует требованиям`
          } catch (e) {
            ToastService.toastErrorTimeout(e, 10000)
          }
        } finally {
          this.isUploading = false
        }
      }
    },
  },

  watch: {
    species() {
      this.species = this.species.trim()
    }
  }
}
</script>

<style scoped>

</style>